// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Twitter1: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
            <rect width="39" height="39" x=".5" y=".5" fill="#000" stroke="#333" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M24.017 13.5h2.161L21.491 19 27 26.5h-4.322L19.3 21.969 15.435 26.5h-2.161l5.022-5.875L13 13.5h4.413l3.074 4.156 3.53-4.156zm-.76 11.688h1.217l-7.7-10.438h-1.278l7.76 10.438z"
            />
        </svg>
    );
};

export default React.memo(Twitter1);
